import { render, staticRenderFns } from "./Tariffe.vue?vue&type=template&id=2f8d0e00"
import script from "./Tariffe.vue?vue&type=script&lang=js"
export * from "./Tariffe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports